import React, { useContext, useEffect, useState } from 'react';
import { APIContext } from 'src/components/Contexts/APIContext'
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { SelectModal } from '../SelectModal';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IMonitoringStatusChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    client: string,
    currentSelection?: any,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
    view?: string;
}

export default function ScorecardTypeChip({ filterName, onSelect, title, client, currentSelection, show, removeFilter, filterFlag, filterNames, view }: IMonitoringStatusChipProps) {
    const { get } = useContext(APIContext);
    const [scorecardTypes, setScorecardTypes] = useState<string[]>([]);

    useEffect(() => {
        get('MonitoringScorecard', `GetScorecardTypes`, (data) => setScorecardTypes(data))
    }, [])


    const handleSelect = (name: any, value: any) => {
        onSelect(name, value);
    }

    const handleDelete = () => {
        if (removeFilter !== null && removeFilter !== undefined) {
            removeFilter(filterFlag, filterNames);
        }
    }

    return (
        <React.Fragment>
            {show
                ?
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{title}</Typography>
                        </Grid>
                        <SelectModal title={title} filterName={filterName} mutliSelect={false} currentSelection={currentSelection} onSelect={handleSelect} options={scorecardTypes} searchable={true} />
                        <Grid>
                            {removeFilter !== null && removeFilter !== undefined ?
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}><CancelIcon /></IconButton> : <React.Fragment />}
                        </Grid>
                    </Grid>
                </Grid>
                :
                <React.Fragment />
            }
        </React.Fragment>)
}